import { render, staticRenderFns } from "./list-customer.vue?vue&type=template&id=657faad0"
import script from "./list-customer.vue?vue&type=script&lang=js"
export * from "./list-customer.vue?vue&type=script&lang=js"
import style0 from "./list-customer.vue?vue&type=style&index=0&id=657faad0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports